@use "src/styles/common/_colors.scss";
.tableHeader {
    tr {
        line-height: 22px;
        color: colors.$white;
        th.select-all-checkbox {
            width: 40px;
        }
        th:first-child {
            border-left: none;
        }
        th {
            position: relative;
            border-bottom: 0px;
            padding: 0.5rem;
            border-left: 1px solid colors.$gray-variant-3;
            border-top: none;
            font-size: 11px;
            line-height: 16px;
            overflow: visible;
            white-space: nowrap;
            text-overflow: ellipsis;
            // background: linear-gradient(
            //     to bottom,
            //     colors.$gray-variant-5 0%,
            //     colors.$gray-variant-6 49%,
            //     colors.$gray-variant-7 51%,
            //     colors.$gray-variant-8 100%
            // );
            background: #232323;
            &.disabled {
                cursor: default;
            }
            &.icon-filter:before {
                color: colors.$green;
            }
            &:hover {
                box-shadow: 0 1px 1px colors.$gray-variant-1;

                background: linear-gradient(
                    to bottom,
                    colors.$gray-variant-1 0%,
                    colors.$gray-variant-2 40%,
                    colors.$gray-variant 50%,
                    colors.$gray-variant-3 100%
                );
            }
            a{
                color: inherit;
            }
        }
    }
}

.headerAction {
    display: inline-block;
    position: absolute;
    right: 10px;
    top: 9px;
    > div[class*="icon-filter"] {
        margin-right: 2px;
    }
}
